import { ApiFactory } from "@/api/ApiFactory.js";

const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    methods: {
        async checkName(vorname, nachname) {
            MitgliederApi.abort();
            const response = await MitgliederApi.get({
                fields: "id, name, vorname",
                filter: {
                    vorname: vorname,
                    name: nachname
                }
            });
            return (
                response.ok &&
                response.json.collection &&
                response.json.collection.length > 0
            );
        },
        async fetchName() {
            const response = await MitgliederApi.getSingle(this.id, {
                fields: ["name", "vorname"]
            });
            if (response.ok) {
                return response.json.vorname + " " + response.json.name;
            }
        },
        async fetchSinger(id) {
            if (id) {
                const response = await MitgliederApi.getMitgliederStatus(id);
                if (response.ok) {
                    const collection = response.json;
                    return collection.singer == 1;
                }
            }
            return false;
        },
        async fetchGuestSinger(id) {
            if (id) {
                const response = await MitgliederApi.getMitgliederStatus(id);
                if (response.ok) {
                    const collection = response.json;
                    return collection.guest_singer == 1;
                }
            }
            return false;
        }
    }
};
